import '../../../App.css'
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Select, Input, Pagination, Modal, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsersAsync } from '../../../redux/slice/userDownlineList/usersSlice';
import { userDepositWithdrawAsync } from '../../../redux/slice/userBanking/userBankingSlice';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { getUserBalanceAsync } from '../../../redux/slice/user/userSlice';


function UserBanking() {
    const params = useParams();
    const dispatch = useDispatch();
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    const { usersList } = useSelector((state) => state.userDownline);
    const { loading: bankingLoading, error: bankingError } = useSelector((state) => state.userBanking);

    let locale = {
        emptyText: 'No data!',
    };


    const columns = [
        {
            title: 'UID',
            dataIndex: 'name',
            // sorter: true,
            // render: (name) => `${name.first} ${name.last}`,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>{record.user_name}</span>
            ),
            width: '5%'
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            // sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem]'>{Number(record.noDeductbalance).toFixed(0)}</span>
            ),
            width: '8%'
            // width: '10%'
        },
        {
            title: 'Available D / W',
            dataIndex: '',
            // sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem]'>{Number(record.balance).toFixed(0)}</span>
            ),
            width: '12%'
            // width: '10%'
        },
        {
            title: 'Exposure',
            dataIndex: 'exposure',
            // sorter: false,
            // width: '10%'
            render: (_, record) => (
                <span className='font-extrabold text-[#d50000] text-[0.813rem]'>{`(${Number(record.exposure).toFixed(0)})`}</span>
            ),
            width: '7%'
        },
        {
            title: 'Credit Ref.',
            dataIndex: 'credit_reference',
            // sorter: true,
            width: '13%',
            render: (_, record) => (
                <div className='flex items-center gap-x-4'>
                    <strong className='text-[#535353] font-extrabold text-[0.813rem]'>{record.credit_reference ? Number(record.credit_reference).toFixed(2) : '-'}</strong>
                    <button
                    // onClick={() => editCreditRef(true, record)}
                    >
                        <svg fill='#535353' className='w-[15px] h-[15px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z" />
                        </svg>
                    </button>
                    <button
                    // onClick={() => creditRefLog(true, record)}
                    >
                        <i className="fa fa-eye text-[#535353]"></i>
                    </button>
                </div>
            )

        },
        {
            title: 'Reference P/L',
            dataIndex: 'name',
            sorter: false,
            render: (_, record) => {
                const pl = (record.noDeductbalance - record.credit_reference).toFixed(0);
                return (
                    <span className={`font-extrabold text-[0.813rem] ${pl > 0 ? 'text-[#008000]' : 'text-[#ff0000]'}`}>
                        {Math.abs(pl).toFixed(0)}
                    </span>
                );
            },
            width: '10%'
        },
        {
            title: 'Deposit/Withdraw',
            dataIndex: 'name',
            sorter: false,
            width: '27%',
            render: (_, record, index) => (
                <div className='flex w-full '>
                    <button
                        className={`credit_btn credit_btn_${index} text-[#23282c]  ml-[5px] !px-[10px] !py-[2px] !border-[1px] !border-[solid] !border-[#333] h-[34px] w-[34px] leading-normal text-center rounded-[.375rem] [transition:color_.15s_ease-in-out,_background-color_.15s_ease-in-out,_border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] ${userArray.find(item => item.user_id == record._id && item.action == 'Credit') ? 'bg-[#008000]' : 'bg-[#acb5bc] '}`}
                        onClick={() => {
                            handleInputChange('Credit', record._id, 'action')
                        }}
                    >
                        <span className='text-[#ffffff] text-[.875rem] font-extrabold'>D</span>
                    </button>
                    <button
                        className={`debit_btn debit_btn_${index} text-[#23282c]  ml-[5px] !px-[10px] !py-[2px] !border-[1px] !border-[solid] !border-[#333] h-[34px] w-[34px] leading-normal text-center rounded-[.375rem] [transition:color_.15s_ease-in-out,_background-color_.15s_ease-in-out,_border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] ${userArray.find(item => item.user_id == record._id && item.action == 'Debit') ? 'bg-[#ff0000]' : 'bg-[#acb5bc] '}`}
                        onClick={() => {
                            handleInputChange('Debit', record._id, 'action')
                        }}
                    >
                        <span className='text-[#ffffff] text-[.875rem] font-extrabold'>W</span>
                    </button>
                    <input
                        id={`amount_of_${record._id}`}
                        type='text'
                        placeholder='0'
                        className='ml-[5px] px-[.75rem] py-[.375rem] text-[.875rem] leading-normal text-[#5c6873] bg-[#fff] bg-clip-padding border-[1px] border-[solid] border-[#e4e7ea] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] font-normal'
                        onChange={(e) => handleInputChange(e.target.value, record._id, 'amount')}
                        value={
                            (userArray.find(item => item.user_id == record._id))?.amount || ''
                        }
                    />
                    <button
                        className={`ml-[5px] font-extrabold !px-[10px] !py-[5px] !text-[.875rem] text-[#ffffff] bg-[linear-gradient(#022c43,_#18b0c8)] border-[#cccccc] border-[unset] leading-normal text-center rounded-[.375rem] h-[34px] [transition:color_.15s_ease-in-out,_background-color_.15s_ease-in-out,_border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out]  `}
                        onClick={handleSubmitPayment}
                        disabled={submitClick}
                    >
                        <strong className='text-[#ffffff] font-extrabold'>Submit</strong>
                    </button>
                </div>
            ),
        },
        // {
        //     title: 'Remark',
        //     // dataIndex: 'remark',
        //     sorter: false,
        //     render: (_, record, index) => (
        //         <input
        //             type='text'
        //             id={`remark_of_${record._id}`}
        //             placeholder='Remark'
        //             className='block w-full px-[.75rem] py-[.375rem] text-[.875rem] leading-normal text-[#5c6873] bg-[#fff] bg-clip-padding border-[1px] border-[solid] border-[#e4e7ea] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] font-normal'
        //             onChange={(e) => handleInputChange(e.target.value, record._id, 'remark')}
        //             value={
        //                 (userArray.find(item => item.user_id == record._id))?.remark || ''
        //             }
        //         />
        //     ),
        // },


    ];

    const [filteredData, setFilteredData] = useState([])
    const [userArray, setUserArray] = useState([])
    const [submitClick, setSubmitClick] = useState(false)
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [password, setPassword] = useState('')

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchUsersAsync({
                page: 1,
                limit: 10,
                search: '',
                sortBy: 'createdAt',
                sortOrder: 'desc'
            }));
        }
    }, [dispatch, isAuthenticated]);

    const handleSearch = (value, dataIndex) => {
        if (!value) {
            setFilteredData([]);
            return;
        }

        const searchTermLower = value.toLowerCase();
        const filtered = usersList.data.filter(item =>
            ['user_name', 'credit_reference', 'balance', 'exposure', 'exposer_limit', 'status']
                .some(key =>
                    item[key] &&
                    item[key].toString().toLowerCase().includes(searchTermLower)
                )
        );

        setFilteredData(filtered);
    };



    const handleInputChange = (value, userId, field) => {
        const userIndex = userArray.findIndex(user => user.user_id === userId);
        if (userIndex === -1) {
            setUserArray(prevArray => [
                ...prevArray,
                {
                    user_id: userId,
                    action: '',
                    amount: '',
                    remark: '',
                }
            ]);
        }

        setUserArray(prevArray => prevArray.map((user, index) => {
            if (user.user_id === userId) {
                return {
                    ...user,
                    [field]: value,
                };
            }
            return user;
        }));
    };


    const handleSubmitPayment = async () => {
        // if (!password) {
        //     message.error('Please enter master password');
        //     return;
        // }

        if (userArray.length === 0) {
            message.error('No users selected for transaction');
            return;
        }

        const invalidTransactions = userArray.filter(
            user => !user.action || !user.amount || parseFloat(user.amount) <= 0
        );

        if (invalidTransactions.length > 0) {
            message.error('Please fill in all transaction details correctly');
            return;
        }

        try {
            setSubmitClick(true);

            const payload = {
                // password: password,
                users: userArray.map(user => ({
                    user_id: user.user_id,
                    action: user.action,
                    amount: user.amount,
                    remark: user.remark || ''
                }))
            };

            if (isAuthenticated) {
                const result = await dispatch(userDepositWithdrawAsync(payload)).unwrap();
                await dispatch(fetchUsersAsync({
                    page: current,
                    limit: pageSize,
                    search: '',
                    sortBy: 'createdAt',
                    sortOrder: 'desc'
                }));
                dispatch(getUserBalanceAsync());
            }
            message.success('Transactions processed successfully');

            clearAll();
        } catch (err) {
            message.error(err.message || 'Failed to process transactions');
        } finally {
            setSubmitClick(false);
        }
    };




    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));


    const clearAll = () => {
        userArray && userArray.forEach((item) => {
            const amountInput = document.getElementById(`amount_of_${item.user_id}`);
            const remarkInput = document.getElementById(`remark_of_${item.user_id}`);

            if (amountInput) amountInput.value = '';
            if (remarkInput) remarkInput.value = '';
        });

        setUserArray([]);
        setPassword('');
    };

    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = filteredData?.length > 0
        ? filteredData.slice(startIndex, endIndex)
        : usersList.data?.slice(startIndex, endIndex) || [];

    return (
        <>
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 relative mt-[20px] lg:mt-[15px]   px-[15px] lg:px-[30px]' >
                    <div className='col-span-12 '>
                        <div className='bg-[#fff] border rounded-[.375rem]'>
                            <div className='p-[1.25rem] flex-auto '>
                                <Table
                                    title={() => (
                                        <div className='grid grid-cols-12 mb-[20px]'>
                                            <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-start mb-[.9rem] lg:mb-[0px]'>
                                                <div className='text-[#333]'>
                                                    <label>
                                                        Show
                                                        <Select defaultValue={10} onChange={handlePageSizeChange} className='pagesize-select mx-[5px]'>
                                                            <Select.Option value={10}>10</Select.Option>
                                                            <Select.Option value={25}>25</Select.Option>
                                                            <Select.Option value={50}>50</Select.Option>
                                                            <Select.Option value={100}>100</Select.Option>
                                                        </Select>
                                                        entries
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-end'>
                                                <div className='text-[#333]'>
                                                    <label>
                                                        Search:
                                                        <Input
                                                            onChange={e => handleSearch(e.target.value, ['name', 'user_name'])}
                                                            style={{ width: '150px', marginLeft: '5px' }}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    locale={locale}
                                    columns={columns}
                                    className='downline-list'
                                    bordered
                                    dataSource={paginatedData}
                                    pagination={false}
                                />
                                <div className='grid grid-cols-12 items-center pt-[1.5rem] lg:pt-[.75rem] text-[#333]'>
                                    <div className='col-span-12 lg:col-span-6 text-[#333] text-[0.813rem]'>
                                        Showing {startIndex + 1} to {endIndex} of {filteredData?.length} entries
                                    </div>
                                    <div className='col-span-12 lg:col-span-6 flex items-center justify-end  pt-[1rem] lg:pt-[0px] lg:mt-[0rem]'>
                                        <button className='text-[0.813rem] cursor-default text-[#666] border-[1px] border-[solid] border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px] cursor-pointer' type='button' onClick={handleFirst} style={{ marginRight: 8 }}>First</button>
                                        <Pagination
                                            current={current}
                                            pageSize={pageSize}
                                            total={filteredData?.length}
                                            onChange={(page) => setCurrent(page)}
                                            itemRender={(page, type, originalElement) => {
                                                if (type === 'prev') {
                                                    return <button type='button' className='!cursor-pointer'>Previous</button>;
                                                }
                                                if (type === 'page') {
                                                    return null;
                                                }
                                                if (type === 'next') {
                                                    return <button type='button' className='!cursor-pointer'>Next</button>;
                                                }
                                                return originalElement;
                                            }}
                                            showSizeChanger={false}
                                        />
                                        <button className='text-[0.813rem] cursor-default text-[#666] border-[1px] border-[solid] border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px]  cursor-pointer' type='button' onClick={handleLast} style={{ marginLeft: 8 }}>Last</button>
                                    </div>
                                </div>
                                <div className='grid grid-cols-12 items-center mt-[30px]'>
                                    {/* <div className='col-span-6 lg:col-span-3 pr-[15px] mb-[1rem] lg:mb-[0px]'>
                                        <button type="button" className="block w-full text-[#fff] bg-[#f86c6b] border-[#f86c6b] font-bold px-[10px] py-[5px] text-[.875rem] text-center border-[1px] border-[solid] border-[#dc3545] rounded-[.375rem]" onClick={clearAll}>Clear All</button>
                                    </div> */}
                                    {/* <div className='col-span-6 lg:col-span-3 pl-[15px] lg:pr-[15px] mb-[1rem] lg:mb-[0px]'>
                                        <input name="paymentPass"
                                            value={password}
                                            placeholder="Password.."
                                            type="password"
                                            className='block w-full px-[.75rem] py-[.375rem] text-[.875rem] leading-normal text-[#5c6873] bg-[#fff] bg-clip-padding border-[1px] border-[solid] border-[#e4e7ea] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] font-normal'
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div> */}
                                    {/* <div className='col-span-12 lg:col-span-3 lg:px-[15px] mb-[1rem] lg:mb-[0px]'>
                                        <button
                                            type="button"
                                            className={`block w-full font-bold px-[10px] py-[5px] text-[.875rem] text-[#ffffff] bg-[linear-gradient(#022c43,_#18b0c8)] border-[#cccccc] text-center rounded-[.375rem] ${submitClick ? 'opacity-[.65] cursor-not-allowed' : ''}`}
                                            onClick={handleSubmitPayment}
                                            disabled={submitClick}
                                        >
                                            {submitClick ? 'Processing...' : 'Submit Payment'}
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        </>
    );
}

export default UserBanking;
